import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function EditModeReducer(
	state = initialState.isEditMode,
	action
) {
	switch (action.type) {
		case types.SET_EDIT_MODE: {
			return action.isEditMode;
		}
		default:
			return state;
	}
}